import CryptoJS from 'crypto-js';
import md5 from 'js-md5';

export default {
	CryptoString(data, key, iv) {
		key = CryptoJS.enc.Latin1.parse(key);
		iv = CryptoJS.enc.Latin1.parse(iv);
		let srcs = CryptoJS.enc.Utf8.parse(data);
		let encrypted = CryptoJS.AES.encrypt(srcs, key, {
			iv,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7
		});
		return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
	},
	buf2hex(buffer) {
		return Array.prototype.map.call(new Uint8Array(buffer), x => ('00' + x.toString(16)).slice(-2)).join('');
	},
	strMd5(str) {
		return md5(str);
	}
};
